import {useFeatureIsOn} from "@growthbook/growthbook-react";
import gql from "graphql-tag";

import type {AppFeatures} from "@khan/analytics-growthbook/app-features";
import {useQuery} from "@khan/data-gql";
import {gqlOp, type GqlOperation} from "@khan/data-gql-core";
import {RequestInfo} from "@khan/shared-core";

import type {
    getDistrictDisallowDiscussions,
    getDistrictDisallowDiscussionsVariables,
} from "./__graphql-types__/getDistrictDisallowDiscussions.ts";

export const DISTRICT_DISALLOW_DISCUSSIONS_QUERY: GqlOperation<
    getDistrictDisallowDiscussions,
    getDistrictDisallowDiscussionsVariables
> = gqlOp(gql`
    query getDistrictDisallowDiscussions {
        user {
            id
            districtDisallowDiscussions
        }
    }
`);

// A list of locales where we want to block discussions
const bannedLocales = ["pt-BR", "pt", "pt-PT"];

export default function useShowDiscussion() {
    const [queryResult] = useQuery(DISTRICT_DISALLOW_DISCUSSIONS_QUERY);

    // We don't show discussions in Portuguese for now (LEMS-2288)
    const shouldBlockLocale = useFeatureIsOn<AppFeatures>(
        "block-discussions-pt",
    );
    const isBlockedInLocale =
        shouldBlockLocale && bannedLocales.includes(RequestInfo.kaLocale);

    const shouldBlockDiscussions =
        // @ts-expect-error - TS2339 - Property profile does not exist on type
        queryResult?.data?.user?.districtDisallowDiscussions === true ||
        isBlockedInLocale;

    return !shouldBlockDiscussions;
}
